import { ActionTypes } from "@/actions";
import { put } from "redux-saga/effects";

const workerUIUpdated = function* (action: any) {
    try {
        put({ type: ActionTypes.UI_UPDATE_MENU_INDEX, payload: action.payload });
    } catch (error: any) {
        console.error('workerUIUpdated', error);
    }
}

export function* watcherUISaga() {
    yield workerUIUpdated;
}